import React from 'react';
import ModalOverlay from '../ModalOverlay/ModalOverlay.tsx';
import styles from './RubrosInfoModal.module.scss';

interface RubrosInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RubrosInfoModal: React.FC<RubrosInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose}>
      <div className={styles.content}>
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Cerrar información"
        >
          ×
        </button>
        <h2 className={styles.title}>Cómo funcionan los rubros</h2>
        <p className={styles.intro}>
          Organizá tu proyecto en rubros para recibir cotizaciones de forma más clara y ordenada.
        </p>
        <ul className={styles.list}>
          <li>Podés crear varios rubros con distintas fechas para escalonar la recepción de cotizaciones.</li>
          <li>Siempre decidís quién puede ver la documentación que sumás en cada rubro.</li>
          <li>Cuanta más documentación agregues (planos, especificaciones, referencias), mejores van a ser las cotizaciones.</li>
          <li>Mientras la publicación esté activa, podés agregar, editar o eliminar rubros cuando lo necesites.</li>
        </ul>
        <div className={styles.footer}>
          <p className={styles.footerText}>
            ¿Dudas o necesitás ayuda? Abrí el{' '}
            <span className={styles.footerHighlight}>asistente con IA de edify</span>{' '}
            desde el botón redondo que ves abajo a la derecha y preguntale lo que necesites, o escribinos a{' '}
            <a href="mailto:contacto@edify.la" className={styles.footerLink}>
              contacto@edify.la
            </a>
            .
          </p>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default RubrosInfoModal;
